export const initialAudition = {
    "audition_id": null,
        "talent_id": null,
        "talent_name": null,
        "role": null,
        "audition_date": null,
        "audition_time": null,
        "status_id": null,
        "notes": null
}